// import { EnvConfig } from "@/envs/local";
import { EnvConfig } from "@/envs/prod";
export default class extends EnvConfig {};